function toggleFreeGiftSection(cart) {

  function updateGiftSection() {
    const freeGiftSection = document.getElementById('free-gift-section');
    const freeGiftContainer = document.getElementById('freegiftblock');
    console.log('updateGiftSection appelé');
    console.log('freeGiftSection:', freeGiftSection);
    console.log('freeGiftContainer:', freeGiftContainer);
    if (!freeGiftSection) {
      return;
    }

    const hasGift = cart.items.find(item => item.properties?._cadeau === "_offert"); 
    const totalPrice = cart.total_price;
    console.log('hasGift:', hasGift);
    console.log('totalPrice:', totalPrice);
    console.log('Condition >= 10000 && !hasGift:', totalPrice >= 10000 && !hasGift);

    if (totalPrice >= 10000 && !hasGift) {
      freeGiftContainer.classList.add('show');
       console.log('Ajout classe show');
    } else {
       console.log('Retrait classe show');
      freeGiftContainer.classList.remove('show');
    }

    if (totalPrice < 10000 && hasGift) {
      removeGiftItem();
    }
  }

  if (document.getElementById('free-gift-section')) {
    updateGiftSection();
  } else {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && document.getElementById('free-gift-section')) {
          updateGiftSection();
          observer.disconnect();
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

document.addEventListener('DOMContentLoaded', function() {
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartData => {
            toggleFreeGiftSection(cartData);
        })
        .catch((error) => {
            console.error('Error fetching cart data:', error);
        });
});

document.addEventListener('ajaxProduct:added', function(evt) {
  console.log('ajaxProduct:added déclenché');
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartData => {
          console.log('Cart total:', cartData.total_price);
            console.log('free-gift-section existe:', !!document.getElementById('free-gift-section'));
            toggleFreeGiftSection(cartData);
        })
        .catch((error) => {
            console.error('Error fetching cart data:', error);
        });
});

document.addEventListener('cart:updated', function(evt) {
    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartData => {
            toggleFreeGiftSection(cartData);
        })
        .catch((error) => {
            console.error('Error fetching cart data:', error);
        });
});

function removeGiftItem() {
  let giftItem;
  if (window.location.pathname === '/cart') {
    giftItem = document.querySelector('tr.cart-item[data-cadeau="true"]');
  } else {
    giftItem = document.querySelector('[data-cadeau="true"]');
  }
  
  if (giftItem) {
    const lineIndex = giftItem.querySelector('cart-remove-button')?.dataset.index;
    if (lineIndex) {
      const cartItemsElement = document.querySelector('cart-items');
      if (cartItemsElement && typeof cartItemsElement.updateQuantity === 'function') {
        cartItemsElement.updateQuantity(lineIndex, 0);
      }
    }
  }
}

